import { j as s } from "./jsx-runtime-3tyXYecC.mjs";
import { useRef as z, useEffect as A, useCallback as S, forwardRef as $ } from "react";
import { L as Z } from "./layout-box-DFBM-kSI.mjs";
import { M as B } from "./masked-input-UstFy78I.mjs";
import { f as i } from "./index-LyFokDcn.mjs";
import { m as T, b as q } from "./tss-DN0acMKN.mjs";
import { I as G } from "./InputAdornment-T4xPPRnD.mjs";
const H = T()((e, n) => {
  const { palette: t, mixins: a } = e, { status: r, disabled: u, viewMode: o } = n;
  return {
    adornment: {
      backgroundColor: "none !important",
      padding: "0 !important"
    },
    focused: i.ifFeature(
      "encore",
      {
        "&&&": {
          ...a.inputOutline(e, { disabled: u, focused: !0, status: r, viewMode: o })
        }
      },
      {
        borderColor: `${r ? t[r].main : t.primary.lighter}`,
        boxShadow: `${q(r ? t[r].main : t.primary.lighter, 0.25)} 0 0 0 2px`
      }
    ),
    input: i.ifFeature("encore", { paddingRight: 0 }, {}),
    root: {
      "& .MuiInputBase-root": {
        overflow: i.ifFeature("encore", "unset"),
        "&:focus-within": i.ifFeature(
          "encore",
          {
            ...a.inputOutline(e, { disabled: u, status: r, viewMode: o })
          },
          {}
        )
      }
    }
  };
});
var m = /* @__PURE__ */ ((e) => (e[e.PREFIXED = 0] = "PREFIXED", e[e.POSTFIXED = 1] = "POSTFIXED", e))(m || {});
const J = (e, n, t = !0) => {
  const a = z(!1);
  return A(() => {
    a.current = !0;
  }, []), S(
    (u, o) => {
      const l = t ? e !== o.unmaskedValue : e !== o.value;
      a.current && l && n && n({
        maskedValue: o.value,
        unmaskedValue: o.unmaskedValue
      });
    },
    [t, e, n]
  );
}, _ = $((e, n) => {
  const {
    allowNegativeValues: t = !0,
    biId: a,
    conformInitialValue: r = !0,
    containerRef: u,
    currencyCode: o,
    currencySymbol: l = "$",
    menuButton: x,
    minValue: R,
    normalizeZeros: k = !0,
    onBlur: v,
    onChange: y,
    padFractionalZeros: C = !0,
    radix: F = ".",
    scale: I = 2,
    size: h = i.ifFeature("encore", void 0, "small"),
    submitUnmaskedValue: c = !0,
    symbolPosition: p = 0,
    thousandsSeparator: w = ",",
    value: E,
    width: j = 5,
    ...f
  } = e, { status: D, viewMode: V, disabled: X } = f, { classes: d } = H({ disabled: X, status: D, viewMode: V }), P = {
    // This keeps the input and output formats in sync
    // so they're both using a period or both using the company settings for the decimal character
    mapToRadix: [c ? "." : F],
    mask: Number,
    min: R,
    normalizeZeros: k,
    padFractionalZeros: C,
    radix: F,
    scale: I,
    signed: t,
    thousandsSeparator: w
  }, M = J(E, y, c), g = (b) => /* @__PURE__ */ s.jsx(
    Z,
    {
      marginRight: b === "start" ? "-8px" : 0,
      marginTop: h === "large" ? void 0 : "1px",
      paddingLeft: b === "start" ? 1.5 : 0.5,
      paddingRight: b === "start" ? 0 : 0.5,
      paddingY: 1,
      children: l
    }
  );
  return /* @__PURE__ */ s.jsx(
    B,
    {
      biId: a,
      classes: { root: d.root },
      conformInitialValue: r,
      containerRef: u,
      InputProps: {
        endAdornment: i.ifFeature(
          "encore",
          /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
            p === m.PREFIXED ? void 0 : g("end"),
            x
          ] }),
          /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
            p === m.PREFIXED ? void 0 : g("end"),
            /* @__PURE__ */ s.jsx(G, { className: d.adornment, position: "end", children: x })
          ] })
        ),
        classes: {
          focused: d.focused,
          input: d.input
        },
        startAdornment: p === m.PREFIXED ? g("start") : void 0
      },
      ...f,
      "data-fabric-component": f["data-fabric-component"],
      MaskOptions: {
        lazy: !1,
        mask: "#",
        blocks: {
          "#": {
            ...P
          }
        },
        commit: M
      },
      onBlur: v,
      ref: n,
      size: h,
      submitUnmaskedValue: c,
      value: E || "",
      width: j
    }
  );
});
export {
  _ as C,
  m as S
};
//# sourceMappingURL=controlled-amount-input-BlMZCnzi.mjs.map
